import TableLoader from "../../../Common/ShimmerLoader/TableLoader";
import { formatAssignmentDateTime } from "./ComplaintStore/useComplaintStore";

const INNER_COLUMNS = [
  "S.No",
  "Assigned To",
  "Status",
  "Action Remarks",
  "Assigned On",
  "Action Taken On",
  "Total Time (Hr:Min)",
  "Assigned By",
];

const ComplaintDetailTable = ({
  assignmentHistory = [],
  isLoading = false,
  statusBadgeStyles,
  subThStyle,
  subTdStyle,
}) => {
  if (isLoading) {
    return <TableLoader rows={4} columns={INNER_COLUMNS.length} height={180} />;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "20%",
          minWidth: 720,
          borderCollapse: "collapse",
          textAlign: "center",
          fontSize: "12px",
        }}
      >
        <thead>
          <tr>
            {INNER_COLUMNS.map((col) => (
              <th key={col} style={subThStyle}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!assignmentHistory.length ? (
            <tr>
              <td colSpan={INNER_COLUMNS.length} style={subTdStyle}>
                No assignment history available
              </td>
            </tr>
          ) : (
            assignmentHistory.map((item, index) => (
              <tr key={`${item.assignedOn}-${index}`}>
                <td style={subTdStyle}>{index + 1}</td>
                <td style={subTdStyle}>{item.assignedTo || "-"}</td>
                <td style={subTdStyle}>
                  <span
                    style={{
                      ...(statusBadgeStyles?.[item.status] ||
                        statusBadgeStyles?.Open ||
                        {}),
                      padding: "2px 8px",
                      borderRadius: 4,
                      display: "inline-block",
                      minWidth: 64,
                    }}
                  >
                    {item.status || "-"}
                  </span>
                </td>
                <td style={subTdStyle}>{item.actionRemarks || "-"}</td>
                <td style={subTdStyle}>
                  {formatAssignmentDateTime(item.assignedOn)}
                </td>
                <td style={subTdStyle}>
                  {formatAssignmentDateTime(item.actionTakenOn)}
                </td>
                <td style={subTdStyle}>{item.totalTime || "-"}</td>
                <td style={subTdStyle}>{item.assignedBy || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ComplaintDetailTable;
